export enum StepIds {
    vehicleDetails = 'vehicle-details',
    listingDetails = 'listing-details',
    descriptionAndPhotos = 'description-and-photos',
    summary = 'summary'
}
